import "@coreui/coreui/dist/css/coreui.min.css";
import {
  CButton,
  CCard,
  CCardBody,
  CCardFooter,
  CCardHeader,
  CCol,
  CRow,
  CBadge,
} from "@coreui/react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import PreviewIcon from "@mui/icons-material/Preview";
import ReplayIcon from "@mui/icons-material/Replay";
import React, { useState, useEffect, useRef } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import postApiCall from "src/server/postApiCall";
import { Toast } from "primereact/toast";
import "../../../src/css/quillp.scss";
import "./Quiz.css";
import FillInTheBlanks from "./QuizComponents/FillInTheBlanks";
import MultipleChoice from "./QuizComponents/MultipleChoice";
import MultipleSelect from "./QuizComponents/MultipleSelect";
import NumericResponse from "./QuizComponents/NumericResponse";
import YesNo from "./QuizComponents/YesNo";
import ReviewQuiz from "./QuizComponents/ReviewQuiz";
import TrueFalse from "./QuizComponents/TrueFalse";
import TextAnswer from "./QuizComponents/TextAnswer";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import FeedBackPop from "../FeedBackPop/FeedBackPop";

function Quizstudentslide({ detail, sectionType }) {
  const [courseDetails, setcourseDetails] = useState(detail || {});
  const questionArray = courseDetails?.questions,
    [questionAnswerData, setQuestionAnswerData] = useState([]),
    [evaluationAnswer, setEvaluationAnswer] = useState([]),
    trainingId1 = window.location.href.split("?")[1],
    assessmentId = window.location.href.split("?")[3],
    [revealScore, setRevealScore] = useState(false),
    [questionIdCount, setQuestionIdCount] = useState([]),
    colorName = localStorage.getItem("ThemeColor"),
    [themes] = useState(colorName),
    navigate = useNavigate(),
    toast = useRef(null),
    [comments, setComments] = useState(""),
    [currentQuestion, setCurrentQuestion] = useState(0),
    [currentIndex, setCurrentIndex] = useState(-1),
    [loading, setLoading] = useState(false),
    [evaluationData, setEvaluationData] = useState(),
    [showReviewList, setShowReviewlist] = useState(false),
    [valueReset, setValueReset] = useState(false),
    [attemptExceeded, setAttemptExceeded] = useState(0),
    [rateCourseVisible, setRateCourseVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isQuestionsFetched, setIsQuestionsFetched] = useState(false);
  const [nextButtonLoading, setNextButtonLoading] = useState(false);
  const [hasNavigated, setHasNavigated] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const [hasReturnedFromReview, setHasReturnedFromReview] = useState(false);
  const blendedId = window.location.href.split("?")[4];
  const learningPlanId = window.location.href.split("?")[5];
  const assignmentId = window.location.href.split("?")[6];

  const courseDetailApi = async (page, detail, setcourseDetails) => {
    try {
      const payload = {
        courseId: trainingId1,
        assessmentId: assessmentId,
        trainingId: detail?.trainingId,
        displayType: detail?.assessment?.displayType,
        questionSerial: page,
        studentAnswers: [],
        question: detail?.assessment?.questionCount,
        blendedProgramId: blendedId || "",
        learningplanId: learningPlanId || "",
        assignmentId: assignmentId || "",
      };

      const res = await postApiCall("getStudentAssessmentQuestions", payload);
      setcourseDetails(res);
      setIsQuestionsFetched(true);
    } catch (err) {
      const errMsg = err?.message || "An error occurred";
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: errMsg,
        life: 3000,
      });
    }
  };

  useEffect(() => {
    if (
      currentPage === 1 &&
      detail &&
      Object.keys(detail).length > 0 &&
      !isQuestionsFetched
    ) {
      setcourseDetails(detail);
      setIsQuestionsFetched(true);
    } else {
      courseDetailApi(currentPage, detail, setcourseDetails);
    }
  }, [detail, currentPage]);

  useEffect(() => {
    if (courseDetails) {
      if (courseDetails?.displayType === 0 ? undefined : "") {
        setCurrentIndex(0);
        setQuestionAnswerData(
          courseDetails?.questions && [courseDetails?.questions[0]]
        );
      } else {
        setQuestionAnswerData(
          courseDetails?.questions && courseDetails?.questions
        );
      }
    }
  }, [courseDetails, sectionType, trainingId1]);

  useEffect(() => {
    if (currentIndex !== -1) {
      setQuestionAnswerData([questionArray[currentIndex]]);
      setCurrentQuestion(currentIndex);
      setValueReset(!valueReset);
    }
  }, [currentIndex]);

  const handleAnswerChange = (questionId, questionTypeID, value) => {
    setEvaluationAnswer((prev) => {
      const filterValue = prev.filter((item) => item.questionId !== questionId);
      return [
        ...filterValue,
        {
          questionId: questionId,
          questionTypeId: questionTypeID,
          answerValue: value,
        },
      ];
    });
    setQuestionIdCount((pre) => {
      if (!pre.includes(questionId)) {
        return [...pre, questionId];
      }
      return pre;
    });
  };

  const addInProgressCourse = async (payload) => {
    try {
      await postApiCall("addInProgressCourse", payload);
    } catch (error) {
      error?.response?.data?.error;
    }
  };

  const finalSubmit = async () => {
    const data = {
      studentAnswers: evaluationAnswer,
      lastAttemptedQuestion: questionIdCount.length,
      markCompleted: 1,
      courseId: parseInt(trainingId1),
      assessmentId: parseInt(assessmentId),
      blendedProgramId: blendedId || "",
      learningplanId: learningPlanId || "",
      assignmentId: assignmentId || "",
    };
    setLoading(true);
    try {
      const res = await postApiCall("addAssessmentUserAnswers", data);
      const resultData = res?.data ?? res;
      if (resultData) {
        setAttemptExceeded(resultData?.attemptRemaining);
        setEvaluationData(resultData);
        setLoading(false);
      }
      return resultData;
    } catch (err) {
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    const res = await finalSubmit();
    setRevealScore(true);
    setLoading(false);

    if (detail?.quizType !== "Quiz") {
      await setCompleteCourseApi("Pass");
      setRateCourseVisible(true);
    } else if (res?.result) {
      await setCompleteCourseApi(res.result);
    }
  };

  const handleCloseWindow = () => {
    if (!hasNavigated) {
      setHasNavigated(true);
      navigate(-1);
    }
  };

  const setCompleteCourseApi = async (result) => {
    const payLoad = {
      courseId: parseInt(trainingId1),
      resultStatus: result,
      blendedProgramId: blendedId || "",
      learningplanId: learningPlanId || "",
      assignmentId: assignmentId || "",
    };
    try {
      await postApiCall("studentCompletedCourse", payLoad);
    } catch (error) { }
  };

  const addUserFeedbackApi = async () => {
    const payLoad = {
      trainingId: parseInt(trainingId1),
      feedback: comments,
      blendedProgramId: blendedId || "",
      learningplanId: learningPlanId || "",
      assignmentId: assignmentId || "",
    };
    try {
      const response = await postApiCall("addUserRating", payLoad);
      if (response) {
        toast?.current?.show({
          severity: "success",
          summary: "Success",
          courseDetails: "Feedback Sent Successfully",
          life: 3000,
        });
        setRateCourseVisible(false);
      }
    } catch (error) { }
  };

  const handlePrevClick = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const handleNextClick = async () => {
    setNextButtonLoading(true);
    try {
      // Save current answers before moving to next question
      await postApiCall("addAssessmentUserAnswers", {
        studentAnswers: evaluationAnswer,
        lastAttemptedQuestion: questionIdCount.length,
        finalSubmit: 0,
        courseId: parseInt(trainingId1),
        assessmentId: parseInt(assessmentId),
        blendedProgramId: blendedId || "",
        learningplanId: learningPlanId || "",
        assignmentId: assignmentId || "",
      });

      // Only update the currentPage - the useEffect will handle the API call
      setCurrentPage((prevPage) => prevPage + 1);
    } catch (err) {
      const errMsg = err?.message || "An error occurred while saving answers";
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: errMsg,
        life: 3000,
      });
    } finally {
      setNextButtonLoading(false);
    }
  };

  const handleRetakeCourse = async () => {
    if (sectionType === "3") {
      const progressStoreData = {
        courseId: trainingId1,
        progressPercentage: 5,
        progressData: {},
        blendedProgramId: blendedId || "",
        learningplanId: learningPlanId || "",
        assignmentId: assignmentId || "",
      };
      addInProgressCourse(progressStoreData);
    }

    try {
      setRevealScore(false);
      setCurrentPage(1);
      setQuestionIdCount([]);
      setEvaluationAnswer([]);

      const res = await postApiCall("getStudentAssessmentQuestions", {
        courseId: trainingId1,
        assessmentId: assessmentId,
        trainingId: detail?.trainingId,
        displayType: detail?.assessment?.displayType,
        questionSerial: 1,
        studentAnswers: [],
        question: detail?.assessment?.questionCount,
        blendedProgramId: blendedId || "",
        learningplanId: learningPlanId || "",
        assignmentId: assignmentId || "",
      });

      setcourseDetails(res);
      setQuestionAnswerData(
        res.displayType === 0 ? [res.questions[0]] : res.questions
      );
      setShowReviewlist(false);
      setHasReturnedFromReview(false);
      setComments("");
    } catch (err) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to retake the quiz. Please try again.",
        life: 3000,
      });
    }
  };

  const handleFinishClick = async () => {
    setRateCourseVisible(true);
  };

  return (
    <>
      <Toast ref={toast} />
      {showReviewList ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            margin: courseDetails?.displayType === 0 ? "100px" : "0px",
          }}
        >
          <CCard style={{ width: "60%" }}>
            <CCardHeader className={`text-center formHeader${themes}`}>
              <div className="flex">
                <div>
                  <strong style={{ fontWeight: "600", fontSize: "30px" }}>
                    {courseDetails.courseName} Summary
                  </strong>
                </div>

                <div className="flex">
                  {courseDetails?.creditsVisible === 1 &&
                    detail?.credit != null &&
                    courseDetails?.quizType === "Quiz" && (
                      <strong className="h6" style={{ fontWeight: "800" }}>
                        Credit :{" "}
                        {String(courseDetails?.credit)
                          .split("")
                          .reduce((count, digit) => count + 1, 0) > 1
                          ? ""
                          : "0"}
                        {courseDetails?.credit}
                      </strong>
                    )}
                  {courseDetails?.timerOn === 1 &&
                    courseDetails?.quizType === "Quiz" && (
                      <strong className="h6" style={{ fontWeight: "800" }}>
                        {" "}
                        | Total Time :
                        {`${parseInt(courseDetails?.hours) > 0
                          ? ` ${courseDetails?.hours} hour`
                          : ""
                          } `}
                        {`${parseInt(courseDetails?.minutes) > 0
                          ? `${courseDetails?.minutes} minutes`
                          : ""
                          } `}
                      </strong>
                    )}
                </div>
              </div>
            </CCardHeader>
            <CCardBody>
              <ReviewQuiz
                trainingId={trainingId1}
                blendedId={blendedId}
                learningPlanId={learningPlanId}
                assignmentId={assignmentId}
              />
            </CCardBody>
            <CCardFooter
              style={{ backgroundColor: "#f0f0f0" }}
              className="fixed-footer"
            >
              <CRow className="justify-content-between">
                <CCol xs="auto">
                  <CButton
                    className={`saveButtonTheme${themes}`}
                    onClick={() => {
                      setShowReviewlist(false);
                      setHasReturnedFromReview(true);
                    }}
                  >
                    <ArrowBackIcon /> Back
                  </CButton>
                </CCol>
              </CRow>
            </CCardFooter>
          </CCard>
        </div>
      ) : (
        <div className={courseDetails?.displayType === 0 ? undefined : ""}>
          <CCard
            className="rounded-0 border-0 no-radius"
            style={{ width: "100%", height: "100vh" }}
          >
            <CCardHeader className={`formHeader${themes} no-radius`} style={{ padding: isMobile ? "10px" : "1rem" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "10px"
                }}
              >
                <strong style={{ fontWeight: "600", fontSize: isMobile ? "18px" : "30px", lineHeigh: "1.2" }}>
                  {courseDetails?.courseName}
                </strong>
                <Button
                  variant="contained"
                  onClick={handleCloseWindow}
                  sx={{
                    bgcolor: "error.main",
                    "&:hover": { bgcolor: "error.dark" },
                    textTransform: "none",
                    fontSize: isMobile ? "12px" : "14px",
                    padding: isMobile ? "4px 12px" : "6px 16px",
                    minWidth: "auto"
                  }}
                >
                  Close
                </Button>
              </div>

              <div>
                <div className="flex">
                  {detail?.credit != null &&
                    courseDetails?.quizType === "Quiz" && (
                      <strong className="h6" style={{ fontWeight: "800" }}>
                        Credit :{" "}
                        {String(detail?.credit)
                          .split("")
                          .reduce((count, digit) => count + 1, 0) > 1
                          ? ""
                          : "0"}
                        {detail?.credit}
                      </strong>
                    )}
                  {courseDetails?.timerOn === 1 &&
                    courseDetails?.quizType === "Quiz" && (
                      <strong className="h6" style={{ fontWeight: "800" }}>
                        {" "}
                        | Total Time :{" "}
                        {`${parseInt(courseDetails?.hours) > 0
                          ? ` ${courseDetails?.hours} hour`
                          : ""
                          } `}
                        {`${parseInt(courseDetails?.minutes) > 0
                          ? `${courseDetails?.minutes} minutes`
                          : ""
                          } `}
                      </strong>
                    )}
                </div>
              </div>
            </CCardHeader>

            {!revealScore ? (
              <>
                <CCardBody>
                  <CRow
                    style={{
                      height: isMobile || isTablet ? "auto" : "80%",
                      width: isMobile || isTablet ? "100%" : "70%",
                    }}
                    className="questionAnswerHeight"
                  >
                    {questionAnswerData &&
                      questionAnswerData?.map((item, index) => {
                        switch (item?.questionTypeId) {
                          case 1:
                            return (
                              <MultipleChoice
                                type={sectionType}
                                key={index}
                                num={
                                  courseDetails?.displayType === 0
                                    ? currentQuestion
                                    : index
                                }
                                question={item.question}
                                data={item.options}
                                onAnswerChange={handleAnswerChange}
                                questionID={item.questionId}
                                questionTypeID={item.questionTypeId}
                                assessmentID={item.assessmentSettingId}
                                trainingId1={trainingId1}
                                assessmentId={assessmentId}
                                questionIdCount={questionIdCount}
                                isQuestionsFetched={isQuestionsFetched}
                                currentPage={currentPage}
                              />
                            );
                          case 2:
                            return (
                              <MultipleSelect
                                type={sectionType}
                                key={index}
                                num={
                                  courseDetails?.displayType === 0
                                    ? currentQuestion
                                    : index
                                }
                                question={item.question}
                                data={item.options}
                                onAnswerChange={handleAnswerChange}
                                questionTypeID={item.questionTypeId}
                                assessmentID={item.assessmentSettingId}
                                questionID={item.questionId}
                                isQuestionsFetched={isQuestionsFetched}
                                currentPage={currentPage}
                              />
                            );
                          case 3:
                            return (
                              <TrueFalse
                                type={sectionType}
                                key={index}
                                num={
                                  courseDetails?.displayType === 0
                                    ? currentQuestion
                                    : index
                                }
                                question={item.question}
                                data={item.options}
                                onAnswerChange={handleAnswerChange}
                                questionID={item.questionId}
                                assessmentID={item.assessmentSettingId}
                                questionTypeID={item.questionTypeId}
                                isQuestionsFetched={isQuestionsFetched}
                                currentPage={currentPage}
                              />
                            );
                          case 4:
                            return (
                              <YesNo
                                type={sectionType}
                                key={index}
                                num={
                                  courseDetails?.displayType === 0
                                    ? currentQuestion
                                    : index
                                }
                                question={item.question}
                                data={item.options}
                                onAnswerChange={handleAnswerChange}
                                questionID={item.questionId}
                                assessmentID={item.assessmentSettingId}
                                questionTypeID={item.questionTypeId}
                                isQuestionsFetched={isQuestionsFetched}
                                currentPage={currentPage}
                              />
                            );

                          case 5:
                            return (
                              <TextAnswer
                                type={sectionType}
                                key={index}
                                num={
                                  courseDetails?.displayType === 0
                                    ? currentQuestion
                                    : index
                                }
                                question={item.question}
                                onAnswerChange={handleAnswerChange}
                                questionID={item.questionId}
                                questionTypeID={item.questionTypeId}
                                trainingId1={trainingId1}
                                assessmentId={assessmentId}
                                questionIdCount={questionIdCount}
                                isCorrect={item.isCorrect}
                                valueReset={valueReset}
                                isQuestionsFetched={isQuestionsFetched}
                                currentPage={currentPage}
                              />
                            );
                          case 6:
                            return (
                              <NumericResponse
                                type={sectionType}
                                key={index}
                                num={
                                  courseDetails?.displayType === 0
                                    ? currentQuestion
                                    : index
                                }
                                question={item.question}
                                data={item.options}
                                questionID={item.questionId}
                                onAnswerChange={handleAnswerChange}
                                assessmentID={item.assessmentSettingId}
                                questionTypeID={item.questionTypeId}
                                valueReset={valueReset}
                                isQuestionsFetched={isQuestionsFetched}
                                currentPage={currentPage}
                              />
                            );
                          case 7:
                            return (
                              <FillInTheBlanks
                                type={sectionType}
                                key={index}
                                num={
                                  courseDetails?.displayType === 0
                                    ? currentQuestion
                                    : index
                                }
                                question={item.question}
                                onAnswerChange={handleAnswerChange}
                                data={item.options}
                                questionID={item.questionId}
                                assessmentID={item.assessmentSettingId}
                                questionTypeID={item.questionTypeId}
                                valueReset={valueReset}
                                isQuestionsFetched={isQuestionsFetched}
                                currentPage={currentPage}
                              />
                            );
                          default:
                            return <p key={index}>No Quiz</p>;
                        }
                      })}
                  </CRow>
                </CCardBody>
                <CCardFooter
                  style={{
                    position: isMobile || isTablet ? "fixed" : "static",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    backgroundColor: "#ffffff",
                    zIndex: 999,
                    boxShadow: isMobile || isTablet ? "0 -4px 10px rgba(0,0,0,0.08)" : "none",
                    padding: isMobile ? "12px" : "0.75rem 1.25rem"
                  }}
                  className="fixed-footer"
                >
                  <CRow className="justify-content-center">
                    {courseDetails?.displayType === 0 && (
                      <CCol xs={12} md="auto" className={isMobile ? "w-100" : ""}>
                        <div
                          style={{
                            gap: isMobile ? "6px" : "1rem",
                            alignItems: "center",
                            display: "flex",
                            justifyContent: isMobile ? "space-between" : "center",
                            width: "100%",
                            flexWrap: isMobile ? "wrap" : "nowrap"
                          }}
                        >
                          {/* Previous Button */}
                          <CButton
                            className={`saveButtonTheme${themes}`}
                            disabled={currentPage === 1}
                            onClick={handlePrevClick}
                            style={{
                              flex: isMobile ? "1 1 40%" : "none",
                              height: isMobile ? "44px" : "auto",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: isMobile ? "13px" : "inherit"
                            }}
                          >
                            <ArrowBackIcon fontSize={isMobile ? "small" : "medium"} /> Previous
                          </CButton>

                          {/* Question Counter */}
                          {courseDetails?.questionCount && (
                            <div
                              style={{
                                fontSize: isMobile ? "0.9rem" : "1.1rem",
                                padding: "0.2rem",
                                fontWeight: "600",
                                whiteSpace: "nowrap",
                                order: isMobile ? -1 : 0,
                                flexBasis: isMobile ? "100%" : "auto",
                                textAlign: "center"
                              }}
                            >
                              {currentPage} / {courseDetails?.questionCount}
                            </div>
                          )}

                          {/* Next Button */}
                          {currentPage < courseDetails?.questionCount && (
                            <CButton
                              className={`saveButtonTheme${themes}`}
                              onClick={handleNextClick}
                              disabled={nextButtonLoading}
                              style={{
                                flex: isMobile ? "1 1 40%" : "none",
                                height: isMobile ? "44px" : "auto",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: isMobile ? "13px" : "inherit"
                              }}
                            >
                              {nextButtonLoading ? (
                                <>
                                  <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                  ...
                                </>
                              ) : (
                                <>
                                  Next <ArrowForwardIcon fontSize={isMobile ? "small" : "medium"} />
                                </>
                              )}
                            </CButton>
                          )}

                          {/* Finish Button - Always Rendered */}
                          <CButton
                            className={`saveButtonTheme${themes}`}
                            color="primary"
                            onClick={handleSubmit}
                            style={{
                              flex: isMobile ? "1 1 100%" : "none",
                              height: isMobile ? "44px" : "auto",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: isMobile ? "14px" : "inherit",
                              marginTop: isMobile ? "4px" : "0"
                            }}
                          >
                            <DoubleArrowIcon fontSize={isMobile ? "small" : "medium"} /> Finish
                          </CButton>
                        </div>
                      </CCol>
                    )}
                  </CRow>
                </CCardFooter>
              </>
            ) : (
              <CCardBody
                style={{
                  height: "90%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {loading ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                    }}
                  >
                    <span
                      className="spinner-border spinner-border-lg"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      maxWidth: "800px",
                      padding: "2rem",
                    }}
                  >
                    {courseDetails?.quizType === "Quiz" ? (
                      <>
                        {/* Completion Message */}
                        <div
                          style={{ textAlign: "center", marginBottom: "2rem" }}
                        >
                          <CBadge
                            color={
                              evaluationData?.result === "Pass"
                                ? "success"
                                : evaluationData?.result === "Fail"
                                  ? "danger"
                                  : "secondary"
                            }
                            style={{
                              fontSize: "1.5rem",
                              padding: "1rem 2rem",
                              borderRadius: "8px",
                            }}
                          >
                            {evaluationData?.result === "Pass" ? (
                              <span>✓ Assessment Completed Successfully!</span>
                            ) : (
                              <span>Assessment Failed</span>
                            )}
                          </CBadge>
                          <h3 style={{ marginTop: "1rem", fontWeight: 600 }}>
                            {detail?.courseName}
                          </h3>
                        </div>

                        {/* Results Card */}
                        <CCard
                          style={{
                            width: "100%",
                            marginBottom: "2rem",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          }}
                        >
                          <CCardBody>
                            <CRow className="text-center">
                              <CCol md={3} className="mb-3">
                                <div>
                                  <strong
                                    style={{
                                      display: "block",
                                      fontSize: "0.9rem",
                                      color: "#6c757d",
                                      marginBottom: "0.5rem",
                                    }}
                                  >
                                    Total Questions
                                  </strong>
                                  <div
                                    style={{
                                      fontSize: "2rem",
                                      fontWeight: "bold",
                                      color: "#495057",
                                    }}
                                  >
                                    {courseDetails?.questionCount || 0}
                                  </div>
                                </div>
                              </CCol>
                              <CCol md={3} className="mb-3">
                                <div>
                                  <strong
                                    style={{
                                      display: "block",
                                      fontSize: "0.9rem",
                                      color: "#6c757d",
                                      marginBottom: "0.5rem",
                                    }}
                                  >
                                    Score
                                  </strong>
                                  <div
                                    style={{
                                      fontSize: "2rem",
                                      fontWeight: "bold",
                                      color: "#495057",
                                    }}
                                  >
                                    {evaluationData?.score || 0}
                                  </div>
                                </div>
                              </CCol>
                              <CCol md={3} className="mb-3">
                                <div>
                                  <strong
                                    style={{
                                      display: "block",
                                      fontSize: "0.9rem",
                                      color: "#6c757d",
                                      marginBottom: "0.5rem",
                                    }}
                                  >
                                    Result
                                  </strong>
                                  <div
                                    style={{
                                      fontSize: "2rem",
                                      fontWeight: "bold",
                                      color:
                                        evaluationData?.result === "Pass"
                                          ? "#28a745"
                                          : evaluationData?.result === "Fail"
                                            ? "#dc3545"
                                            : "#495057",
                                    }}
                                  >
                                    {evaluationData?.result || "N/A"}
                                  </div>
                                </div>
                              </CCol>
                            </CRow>
                          </CCardBody>
                        </CCard>

                        {/* Action Buttons */}
                        <div
                          style={{
                            display: "flex",
                            gap: "1rem",
                            flexWrap: "wrap",
                            justifyContent: "center",
                            width: "100%",
                          }}
                        >
                          {/* If failed and returned from review: only show Retake */}
                          {evaluationData?.result === "Fail" &&
                            hasReturnedFromReview ? (
                            attemptExceeded !== 0 && (
                              <CButton
                                className={`saveButtonTheme${themes}`}
                                onClick={() => handleRetakeCourse()}
                                style={{ minWidth: "150px" }}
                              >
                                <ReplayIcon /> Retake
                              </CButton>
                            )
                          ) : evaluationData?.result === "Fail" ? (
                            <>
                              {/* If failed (first time): show Retake and Review */}
                              {attemptExceeded !== 0 && (
                                <CButton
                                  className={`saveButtonTheme${themes}`}
                                  onClick={() => handleRetakeCourse()}
                                  style={{ minWidth: "150px" }}
                                >
                                  <ReplayIcon /> Retake
                                </CButton>
                              )}
                              <CButton
                                className={`saveButtonTheme${themes}`}
                                onClick={() => {
                                  setShowReviewlist(true);
                                }}
                                style={{ minWidth: "150px" }}
                              >
                                <PreviewIcon /> Review
                              </CButton>
                            </>
                          ) : evaluationData?.result === "Pass" &&
                            hasReturnedFromReview ? (
                            <>
                              {/* If passed and returned from review: only show Finish */}
                              <CButton
                                className={`saveButtonTheme${themes}`}
                                onClick={handleFinishClick}
                                style={{ minWidth: "150px" }}
                              >
                                <DoubleArrowIcon /> Finish
                              </CButton>
                            </>
                          ) : (
                            <>
                              {/* If passed (first time): show Review, Retake, and Finish */}
                              <CButton
                                className={`saveButtonTheme${themes}`}
                                onClick={() => {
                                  setShowReviewlist(true);
                                }}
                                style={{ minWidth: "150px" }}
                              >
                                <PreviewIcon /> Review
                              </CButton>
                              {attemptExceeded !== 0 && (
                                <CButton
                                  className={`saveButtonTheme${themes}`}
                                  onClick={() => handleRetakeCourse()}
                                  style={{ minWidth: "150px" }}
                                >
                                  <ReplayIcon /> Retake
                                </CButton>
                              )}
                              <CButton
                                className={`saveButtonTheme${themes}`}
                                onClick={handleFinishClick}
                                style={{ minWidth: "150px" }}
                              >
                                <DoubleArrowIcon /> Finish
                              </CButton>
                            </>
                          )}
                        </div>
                      </>
                    ) : null}
                  </div>
                )}
              </CCardBody>
            )}
          </CCard>
        </div>
      )}
      <FeedBackPop
        visible={rateCourseVisible}
        onHide={() => {
            setRateCourseVisible(false);
          }}
        themes={themes}
        courseId={parseInt(trainingId1)}
        blendedIdcode={blendedId || ""}
        learningPlanIdcode={learningPlanId || ""}
        assignmentIdcode={assignmentId || ""}
        grpTrainingId={0}
        onSubmit={() => {
          setRateCourseVisible(false);
          if (!hasNavigated) {
            setHasNavigated(true);
            navigate(-1);
          }
        }}
      />
    </>
  );
}

export default Quizstudentslide;
